import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  companiaLength: 0,
  compania: [],
}

export default function companiaReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_COMPANIA:
      return {...state, loading: action.payload}
    case actions.GET_COMPANIA:
      return {...state, compania: action.payload.compania, companiaLength: action.payload.companiaLength}
    default:
      return state
  }
}